import React from 'react';
import { RadialProgress, Icon } from 'ui';
import colors from 'constants/colors';

const Progress = ({ completed, total, formatted, isOverdue }) => (
  <div className="LearnContentCardProgress">
    <div className="LearnContentCardProgress-icon">
      {completed > 0 ? (
        <RadialProgress
          size={14}
          progress={completed / total}
          fgColor={isOverdue ? colors.RED_DARK : colors.GREEN}
          bgColor={colors.GRAY_LIGHTER}
        />
      ) : (
        <Icon className="fz-bigger" name="path" />
      )}
    </div>
    <div className="LearnContentCardProgress-label">{formatted}</div>
  </div>
);

export default Progress;
